export const types = {
    text: {
        name: 'text',
        height: '1rem',
        width: '100%',
        borderRadius: '0.25rem',
        margin: '0 0 0.25rem'
    },
    avatar: {
        name: 'avatar',
        height: '40px',
        width: '40px',
        borderRadius: '50%',
        margin: '0 0 0.75rem'
    },
    image: {
        name: 'image',
        height: '150px',
        width: '100%',
        borderRadius: '0.25rem',
        margin: '0 0 0.75rem'
    },
    button: {
        name: 'button',
        height: '36px',
        width: '64px',
        borderRadius: '0.25rem',
        margin: '0 0 0.75rem'
    },
    chip: {
        name: 'chip',
        height: '32px',
        width: '96px',
        borderRadius: '1rem',
        margin: '0 0.75rem 0.75rem 0'
    },
    divider: {
        name: 'divider',
        height: '1px',
        width: '100%',
        borderRadius: '0',
        margin: '0 0 0.75rem'
    }
}
